import Sidebar from './Sidebar';

export default function Layout({ children }) {
    return (
        <div style={{ display: 'flex', minHeight: '100vh', background: '#F2F3F4' }}>
            <Sidebar />
            <main style={{ flex: 1, padding: '32px', overflowY: 'auto' }}>
                {children}
            </main>
        </div>
    );
}
